String.prototype.toDate = function (mask) {
    if (!this) return null;
    mask = mask ? mask : 'DD.MM.YYYY';
    this.split('.');
    return new Date(getNum(this, mask, 'YYYY'), getNum(this, mask, 'MM') - 1, getNum(this, mask, 'DD'));

    function getNum(val, mask, type) {
        let a = mask.indexOf(type);
        let b = '';
        for (let i = 0; i < type.length; i++) {
            b += val[a + i];
        }
        return b * 1;
    }
};